import { Length } from "@shared/common/utils/length";
import { Action } from "@opstel/query/v2/models/action";
import { ShuntingUnit } from "@opstel/query/models/shuntingUnit";
import { BlockedDuration } from "@opstel/query/models/track";
import { ActiveOccupation } from "@opstel/query/models/trackOccupation";
import { DateTime } from "luxon";

export function isPassing(activeOccupations: ActiveOccupation[]): boolean {
  return (
    activeOccupations.length > 0 &&
    activeOccupations.every((activeOccupation) =>
      Action.isMoveOrTeleport(activeOccupation.activeAction),
    )
  );
}

export function isBlocked(blockedDurations: BlockedDuration[], selectedTime: DateTime): boolean {
  return (
    blockedDurations.find(
      (blockedDuration) =>
        blockedDuration.startTime <= selectedTime &&
        blockedDuration.endTime >= selectedTime &&
        blockedDuration.blockedType === "NoMoveNoMaterial",
    ) !== undefined
  );
}

export function isThirdParty(activeOccupations: ActiveOccupation[]): boolean {
  return activeOccupations.some((activeOccupation) =>
    activeOccupation.shuntingUnit.planTrainUnits.inAnyDirection().some((unit) => unit.isThirdParty),
  );
}

export function calculateOccupiedLength(activeOccupations: ActiveOccupation[]): Length {
  return new Length(
    activeOccupations
      .filter((occupation) => !Action.isMoveOrTeleport(occupation.activeAction))
      .map((occupation) => ShuntingUnit.totalLength(occupation.shuntingUnit).inMillimeters())
      .reduce((a, b) => a + b, 0),
  );
}
